import { Link } from 'react-router-dom';
import Logo from '../../components/feature/Logo';

export default function Impressum() {
  return (
    <div className="min-h-screen bg-white">
      {/* Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebPage",
                "@id": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/impressum`,
                "url": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/impressum`,
                "name": "Impressum – LearnSnap | Future Now UG",
                "description": "Impressum der LearnSnap-Plattform. Angaben gemäß § 5 TMG: Future Now UG, Max-Planck-Str. 4, 85609 Aschheim.",
                "inLanguage": "de",
                "isPartOf": { "@id": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/#website` }
              },
              {
                "@type": "Organization",
                "@id": `${import.meta.env.VITE_SITE_URL || 'https://learnsnap.online'}/#organization`,
                "name": "Future Now UG",
                "legalName": "Future Now UG (haftungsbeschränkt)",
                "url": import.meta.env.VITE_SITE_URL || 'https://learnsnap.online',
                "email": "info@future-now.online",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "Max-Planck-Str. 4",
                  "addressLocality": "Aschheim",
                  "postalCode": "85609",
                  "addressCountry": "DE"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "email": "info@future-now.online",
                  "contactType": "customer service",
                  "availableLanguage": "German"
                }
              }
            ]
          })
        }}
      />
      {/* Header */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="cursor-pointer">
              <Logo size="md" showText={true} />
            </Link>
            <Link to="/" className="text-slate-600 hover:text-teal-600 font-medium transition-colors cursor-pointer">
              <i className="ri-arrow-left-line mr-2"></i>
              Zurück zur Startseite
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-slate-900 mb-8">Impressum</h1>
        
        <div className="prose prose-slate max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-6">Angaben gemäß § 5 TMG</h2>
            <div className="bg-slate-50 rounded-xl p-8 border border-slate-200">
              <p className="text-slate-900 font-semibold text-lg mb-4">Future Now UG (haftungsbeschränkt)</p>
              <div className="space-y-2 text-slate-700">
                <p><strong>Adresse:</strong></p>
                <p>Max-Planck-Str. 4</p>
                <p>85609 Aschheim</p>
                <p>Deutschland</p>
                
                <p className="mt-6"><strong>Kontakt:</strong></p>
                <p>E-Mail: <a href="mailto:info@future-now.online" className="text-teal-600 hover:text-teal-700 font-medium">info@future-now.online</a></p>
                
                <p className="mt-6"><strong>Vertreten durch:</strong></p>
                <p>Geschäftsführer: Olaf Niggemann</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Registereintrag</h2>
            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
              <p className="text-slate-700">
                <strong>Registergericht:</strong> Amtsgericht München<br />
                <strong>Registernummer:</strong> [Wird ergänzt]
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Umsatzsteuer-ID</h2>
            <p className="text-slate-700 leading-relaxed">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              <strong>[Wird ergänzt]</strong>
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200">
              <p className="text-slate-700">
                Olaf Niggemann<br />
                Max-Planck-Str. 4<br />
                85609 Aschheim
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">EU-Streitschlichtung</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
            </p>
            <p className="text-slate-700">
              <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-teal-600 hover:text-teal-700 font-medium">
                https://ec.europa.eu/consumers/odr/
              </a>
            </p>
            <p className="text-slate-700 leading-relaxed mt-4">
              Unsere E-Mail-Adresse finden Sie oben im Impressum.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Verbraucherstreitbeilegung / Universalschlichtungsstelle</h2>
            <p className="text-slate-700 leading-relaxed">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Haftung für Inhalte</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Haftung für Links</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Urheberrecht</h2>
            <p className="text-slate-700 leading-relaxed mb-4">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            </p>
            <p className="text-slate-700 leading-relaxed">
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>
          </section>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12 mt-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <Logo size="sm" showText={true} textColor="text-white" />
            </div>
            <div className="flex items-center gap-6 text-sm text-slate-400">
              <Link to="/impressum" className="hover:text-white transition-colors cursor-pointer">Impressum</Link>
              <Link to="/datenschutz" className="hover:text-white transition-colors cursor-pointer">Datenschutz</Link>
              <Link to="/agb" className="hover:text-white transition-colors cursor-pointer">AGB</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
